var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"menu"},[_c('router-link',{attrs:{"to":"/OurPassion"}},[_vm._v(" 私たちの想い ")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/SimulateBiogas"}},[_vm._v(" 空き地を活用したい方 ")]),_c('router-link',{attrs:{"to":"/SimulateWeed"}},[_vm._v(" | 世帯数から必要な雑草量を計算する ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }